// OIDC (Authorization Code + PKCE) support. Loaded lazily so dev mode never ships the library.

export const OIDC_CALLBACK_PATH = "/auth/callback";

let managerPromise = null;

export function getOidcManager(config) {
  if (!managerPromise) {
    managerPromise = import("oidc-client-ts").then(({ UserManager, WebStorageStateStore }) => {
      return new UserManager({
        authority: config.issuer,
        client_id: config.clientId,
        redirect_uri: `${window.location.origin}${OIDC_CALLBACK_PATH}`,
        post_logout_redirect_uri: `${window.location.origin}/`,
        response_type: "code",
        scope: "openid profile email",
        automaticSilentRenew: true,
        userStore: new WebStorageStateStore({ store: window.sessionStorage }),
      });
    });
  }
  return managerPromise;
}

export async function getOidcAccessToken(config) {
  const mgr = await getOidcManager(config);
  const user = await mgr.getUser();
  if (!user || user.expired) return null;
  return user.access_token;
}

export async function oidcSignIn(config, returnTo) {
  const mgr = await getOidcManager(config);
  await mgr.signinRedirect({ state: { returnTo } });
}

export async function oidcCompleteSignIn(config) {
  const mgr = await getOidcManager(config);
  const user = await mgr.signinRedirectCallback();
  return user?.state?.returnTo || "/";
}

export async function oidcSignOut(config) {
  const mgr = await getOidcManager(config);
  try {
    await mgr.signoutRedirect();
  } catch {
    await mgr.removeUser();
    window.location.assign("/");
  }
}
